import React from 'react';

export const statusTypes = Object.freeze({
  SUSPENDED_THEFT_OR_LOSS: 'SuspendedTheftOrLoss',
  SUBSCRIBER_IS_ACTIVE: 'SubscriberIsActive',
  ACT_CODE_ACTIVATION: 'ActCodeActivation',
  NOT_BELONG_TO_ORG: 'NotBelongToOrg',
  BELONG_TO_DIFFERENT_ORG: 'BelongToDifferentOrg',
  PROVIDER_1428_RELATED_ERROR: 'Provider1428RelatedError',
  SUSPENDED: 'Suspended',
  ACT_CODE_NOT_EXIST: 'ActCodeNotExist',
  PROVIDER_1716_RELATED_ERROR: 'Provider1716RelatedError',
  GENERAL_ERROR: 'GeneralError',
});

export const pageTypes = Object.freeze({
  START: 'start',
  ESIM_UPGRADE_START: 'esimUpgradeStart',
  GENERAL_ERROR: 'generalError',
  SUBSCRIBER_IS_SUSPENDED_ERROR: 'subscriberIsSuspendedError',
  FINAL_SUCCESS_PAGE: 'finalSuccessPage',
});
